import { SafeBaseObject } from '@app/core/models/base-object.models'
import { DateTime } from 'luxon'
import { BookingGuest, ResGuestType } from './res-booking.model'
import { ResBookingPayerMngmtPayers } from './res-payment.model'
import { v4 as uuid } from 'uuid';
import { ResSrvOptServiceOccupancy } from '@app/res-common/models/rescom-service.model';
export class ResGroups {
	id = 0
	description = ''
	code = ''
	country = ''
	attributes: any[] = []
}
export class ResGuestGroup extends SafeBaseObject {
	groupGuestID = 0
	bkgID = 0
	paxGroupID = 0
	guestID = 0
	title = ''
	lastName = ''
	firstName = ''
	individualID = 0
	guestType = ''
	payerGroupID = 0

	middleName = ''
	gender = ''
	individualType = ''
	country = ''
	householdId = 0

	constructor(data?: any) {
		super()

		if (data) {
			super.updateData(data)
			this.updateData(data)
		}
	}

	override updateData(_: any) { }
}
export class ResPayerGroup extends SafeBaseObject {
	payerGroupID = 0
	payerGroupName = ''
	payerGroupType = ''

	get description() {
		let groupNameExpanded = ''
		if (this.payerGroupID === -1) {
			groupNameExpanded = `[BKG OWNER]`
		} else {
			groupNameExpanded = `[${this.payerGroupType} ${this.payerGroupID}]`
		}
		return `${this.payerGroupName} ${groupNameExpanded}`
	}

	constructor(data?: any) {
		super()

		if (data) {
			super.updateData(data)
			this.updateData(data)
		}
	}

  static fromResBookingPayerMngmtPayers(data:ResBookingPayerMngmtPayers) {
    const item = new ResPayerGroup()
    item.payerGroupID = data.payerID
    item.payerGroupName = data.payerName
    item.payerGroupType = data.payerRole
    return item
  }

	override updateData(_: any) { }
}

export class ResPayerGroupList extends SafeBaseObject {
	paxGroupID = 0
	payer = ''

	constructor(data?: any) {
		super()
		if (data) {
			this.updateData(data)
		}
	}
}

export class ResOandaCurrency extends SafeBaseObject {
	currencyFrom = ''
	currencyTo = ''
	exchangeRate = 0

	get description() {
		return `From ${this.currencyFrom} To ${this.currencyTo} - ROE ${this.exchangeRate}`
	}

	constructor(data?: any) {
		super()
		this.updateData(data)

	}

	override updateData(data?: any) {
		if (data) {
			super.updateData(data)
		}
	}
}

export class ResPayerDepartment extends SafeBaseObject {
	paymentDepartmentID = 0
	companyID = 0
	paymentDepartment = ''
	costCenter = ''
	GLAccount = ''

	get description() {
		return `${this.paymentDepartment} [${this.costCenter} - ${this.paymentDepartmentID}]`
	}

	constructor(data?: any) {
		super()

		if (data) {
			super.updateData(data)
			this.updateData(data)
		}
	}

	asResPayerGroup() {
		const payer = new ResPayerGroup()

		payer.payerGroupID = this.paymentDepartmentID
		payer.payerGroupName = this.paymentDepartment
		payer.payerGroupType = this.costCenter

		return payer
	}

	override updateData(_: any) { }
}
export class ResTrasportVehicle {
  vehicleID = 0
  vehicleGuid = ''
  guests:  BookingGuest[] = []
  get guestCodes() {
    return this.guests.map(item=>item.guestCod)
  }

  clone() {
		const n = new ResTrasportVehicle()
    n.vehicleGuid = uuid()
    n.vehicleID = 0

		return n
	}
  static newVehicle(vehicleID:number) {
    const v = new ResTrasportVehicle()
    v.vehicleID = vehicleID
    v.vehicleGuid = uuid()
    return v
  }
}

export class ResTrasportAccomodation {
  minPax = 1
  maxPax = 99
  guestNumber = 1
  guests: BookingGuest[] = []
  vehicles: ResTrasportVehicle[] = []

  constructor() {
    this.vehicles = [ResTrasportVehicle.newVehicle(1)]
  }
  clone() {
		const n = new ResTrasportAccomodation()
		n.guestNumber = this.guestNumber
		n.minPax = this.minPax
		n.maxPax = this.maxPax
		this.guests.forEach(g => n.guests.push(g.cloneForAccomodation()))
		this.vehicles.forEach(v => n.vehicles.push(v.clone()))
		return n
	}

  static cloneTrasport(trasport: ResTrasportAccomodation, guests:BookingGuest[] = []) {
		const n = new ResTrasportAccomodation()
    n.vehicles = trasport.vehicles.map(item => ResTrasportVehicle.newVehicle(item.vehicleID))
    n.guests = guests

    return n
  }
}
export class ReservationAccomodation {
	Adult = 2
	Child = 0
	Child2 = 0
	Infant = 0
	RoomID = 1
	RoomGUID?: string
	SuiteNumber?: number
	SuiteCategory?: string
	MultiSuiteNumber: number[] = []
	MultiSuiteCategory: string[] = []
	MultiSuiteVoyageID: number[] = []
	MultiSuiteVoyageName: string[] = []
	MultiSuiteGuestCod: string[] = []
	ServiceTypeID?: number
	Guests: BookingGuest[] = []
	PayerID = 0
	PropertyID = 0
	ServiceID = 0
	OptionID = 0

	SellingPrice = 0
	Cost = 0
	ROE = 0
	OnRequest = false
	Markup = 0
	Selected = false
	allSelected = false
	isNew = false
	adultMin = 1
	adultMax = 99
	childMin = 1
	childMax = 99
	child2Min = 1
	child2Max = 99
	infantMin = 1
	infantMax = 99
	roomMaxSize = 0
	roomMinSize = 0
	roomDescription = ''
	roomServiceName = ''
	roomOptionName = ''
  roomService = ''
	roomOptionID = 0
	roomOptionKey = ''
	roomServiceID = 0

  maxAdults = 0
  maxChild = 0
  maxChild2 = 0
  maxinfant = 0

  occupancy: ResSrvOptServiceOccupancy[] = []

	dateStart = DateTime.invalid('EMPTY')
	dateEnd = DateTime.invalid('EMPTY')
	dateCheckOut = DateTime.invalid('EMPTY')

	get suiteAssigned() {
		const elementStart = `<div>`
		const info = this.MultiSuiteNumber.length > 0 ? this.MultiSuiteNumber.map((s, idx) => this.MultiSuiteVoyageName[idx] + ': ' + (s === 0 ? '#' : s) + ' - ' + this.MultiSuiteCategory[idx]).join('\u{000A}') : ''
		const elementIcon = `<i class="fas fa-info-circle text-primary" title="${info}"></i>`
		const elementEnd = `</div>`
		if (this.MultiSuiteNumber.length > 0) return `${elementStart}Suites ${elementIcon}<br/>${this.MultiSuiteNumber.map(s => s === 0 ? '#' : s).join(' ')}${elementEnd}`
		return `Suite ${this.SuiteNumber ?? '…'}<br/>${this.SuiteCategory ?? ''}`
	}
	get filledGuests() {
		return this.Guests.filter(g => !g.isPlaceHolder).length
	}
	static newRoom(roomID: number, serviceTypeID?: number) {
		const n = new ReservationAccomodation()
		n.RoomID = roomID
		n.ServiceTypeID = serviceTypeID
		return n
	}
	get minOccupancy() {
		return this.Adult + this.Child + this.Child2
	}
	get groupSize() {
		return this.Adult + this.Child + this.Child2 + this.Infant
	}
	get guestTotal() {
		return this.Guests.filter(g => g.isSelected).length
	}
	get hasSelection() {
		return this.Guests.find(g => g.isSelected)
	}
	clone() {
		const n = new ReservationAccomodation()
		n.Adult = this.Adult
		n.Child = this.Child
		n.Infant = this.Infant
		n.ServiceTypeID = this.ServiceTypeID
		this.Guests.forEach(g => n.Guests.push(g.cloneForAccomodation()))
		return n
	}
  static cloneAccomodation(roomID:number, accomodation: ReservationAccomodation, guests:BookingGuest[] = []) {
		const n = ReservationAccomodation.newRoom(roomID)
    n.Guests = guests
    n.RoomGUID = uuid()
    n.RoomID                       = roomID
    n.isNew                        = true

    n.SuiteCategory                = accomodation.SuiteCategory
    n.ServiceTypeID                = accomodation.ServiceTypeID
    n.PayerID                      = accomodation.PayerID
    n.PropertyID                   = accomodation.PropertyID
    n.ServiceID                    = accomodation.ServiceID
    n.OptionID                     = accomodation.OptionID

    n.SellingPrice                 = accomodation.SellingPrice
    n.Cost                         = accomodation.Cost
    n.ROE                          = accomodation.ROE
    n.OnRequest                    = true
    n.Markup                       = accomodation.Markup
    n.Selected                     = accomodation.Selected
    n.allSelected                  = accomodation.allSelected
    n.adultMin                     = accomodation.adultMin
    n.adultMax                     = accomodation.adultMax
    n.childMin                     = accomodation.childMin
    n.childMax                     = accomodation.childMax
    n.child2Min                    = accomodation.child2Min
    n.child2Max                    = accomodation.child2Max
    n.infantMin                    = accomodation.infantMin
    n.infantMax                    = accomodation.infantMax
    n.roomMaxSize                  = accomodation.roomMaxSize
    n.roomMinSize                  = accomodation.roomMinSize
    n.roomDescription              = accomodation.roomDescription
    n.roomServiceName              = accomodation.roomServiceName
    n.roomOptionName               = accomodation.roomOptionName
    n.roomService                  = accomodation.roomService
    n.roomOptionID                 = accomodation.roomOptionID
    n.roomOptionKey                = accomodation.roomOptionKey
    n.roomServiceID                = accomodation.roomServiceID
    n.occupancy                    = accomodation.occupancy

    n.maxAdults                    = accomodation.maxAdults
    n.maxChild                     = accomodation.maxChild
    n.maxChild2                    = accomodation.maxChild2
    n.maxinfant                    = accomodation.maxinfant

    n.dateStart                    = DateTime.fromJSDate(accomodation.dateStart.toJSDate())
    n.dateEnd                      = DateTime.fromJSDate(accomodation.dateEnd.toJSDate())
    n.dateCheckOut                 = DateTime.fromJSDate(accomodation.dateCheckOut.toJSDate())

    return n
  }
  displayGuestType(guest:BookingGuest) {
    if(guest.isAdult && guest.age===0) return `(A)`
    if(guest.isAdult) return `Age: ${guest.age} (A)`
    if(guest.isChild) {
      if(guest.age===0) return '(C)'
      if(this.occupancy.length===0) return `Age: ${guest.age} (C)`
      const adultAge = this.occupancy[0].childToAge
      if(guest.age > adultAge) return `Age: ${guest.age} (A+${adultAge})`
    }
    return '(A)'
  }
	guestsHtml() {
		let html = '<div class="res-acc-html">'

		this.Guests
			.forEach(g => {
				html += `<div>${g.displayNameFullWithCod()}</div>`
			})

		html += '</div>'
		return html
	}
	recomputeGuestsNumber() {
		this.Adult = this.Guests.filter(g => g.guestType === ResGuestType.Adult).length
		this.Child = this.Guests.filter(g => g.guestType === ResGuestType.Child).length
		this.Child2 = this.Guests.filter(g => g.guestType === ResGuestType.Child2).length
		this.Infant = this.Guests.filter(g => g.guestType === ResGuestType.Infant).length
	}
	static syncGuestPlaceholder(accomodation: ReservationAccomodation, startGuestCod = 0, lastName = 'QUOTE') {
		let tempGuestCod = startGuestCod
		for (let i = accomodation.Guests.filter(g => g.guestType === ResGuestType.Adult).length + 1; i <= accomodation.Adult; i++) {
			tempGuestCod++
			const guest = BookingGuest.newPlaceholder(tempGuestCod, accomodation.RoomID, lastName)
			guest.firstName = i.toString()
			guest.guestType = ResGuestType.Adult
			guest.roomID = accomodation.RoomID
			accomodation.Guests.push(guest)
		}
		for (let i = accomodation.Guests.filter(g => g.guestType === ResGuestType.Child).length + 1; i <= accomodation.Child; i++) {
			tempGuestCod++
			const guest = BookingGuest.newPlaceholder(tempGuestCod, accomodation.RoomID, lastName)
			guest.firstName = i.toString()
			guest.guestType = ResGuestType.Child
			guest.roomID = accomodation.RoomID
			accomodation.Guests.push(guest)
		}
		for (let i = accomodation.Guests.filter(g => g.guestType === ResGuestType.Child2).length + 1; i <= accomodation.Child2; i++) {
			tempGuestCod++
			const guest = BookingGuest.newPlaceholder(tempGuestCod, accomodation.RoomID, lastName)
			guest.firstName = i.toString()
			guest.guestType = ResGuestType.Child2
			guest.roomID = accomodation.RoomID
			accomodation.Guests.push(guest)
		}
		for (let i = accomodation.Guests.filter(g => g.guestType === ResGuestType.Infant).length + 1; i <= accomodation.Infant; i++) {
			tempGuestCod++
			const guest = BookingGuest.newPlaceholder(tempGuestCod, accomodation.RoomID, lastName)
			guest.firstName = i.toString()
			guest.guestType = ResGuestType.Infant
			guest.roomID = accomodation.RoomID
			accomodation.Guests.push(guest)
		}
	}

}

export class ReservationSetupOption extends SafeBaseObject {
	brandID?: number
	commissionable = false
	isSBC = false
	maxPax?: number
	minPax?: number
	optionDesc?: string
	optionID?: number
	optionName?: string
	optionShortName?: string
	optionDisplayName?: string
	optionTypeID?: number
	optionType?: string
	refundable = false
	serviceID?: number
	serviceName?: string
	serviceTypeName?: string
	status?: string
	taxTypeID?: number
	taxValue?: number
	Flag?: string
	priceSetupID?: number
	sbcMessage?: string
	isDayRoom = false
	areConnectedServicesPresent = false
	companyName = ''

	get formattedStatus(): string {
		switch (this.status) {
			case 'A':
				return 'Active'
			case 'D':
				return 'Deleted'
			case 'B':
				return 'Inactive'
			default:
				return ''
		}
	}

	constructor(data?: any) {
		super()
		if (data) {
			this.updateData(data);
		}
	}
}

export class ReservationSetupSequenceDiscount extends SafeBaseObject {
	brandID?: number
	commissionable?: boolean
	isSBC?: boolean
	maxPax?: number
	minPax?: number
	optionDesc?: string
	optionID?: number
	optionName?: string
	optionShortName?: string
	optionTypeID?: number
	optionType?: string
	refundable?: boolean
	serviceID?: number
	serviceName?: string
	serviceTypeName?: string
	status?: string
	taxTypeID?: number
	taxValue?: number
	Flag?: string
	priceSetupID?: number
	optionCod?: number
	sequenceDiscount?: number
	placedAfter?: string

	get formattedStatus(): string {
		switch (this.status) {
			case 'A':
				return 'Active'
			case 'D':
				return 'Deleted'
			default:
				return ''
		}
	}

	constructor(data?: any) {
		super()

		this.commissionable = false
		this.isSBC = false
		this.refundable = false

		if (data) {
			this.updateData(data)
		}
	}

	override updateData(data: any): void {
		this.addMangledProperty(data)
		this.addBooleanProperty('commissionable', data, 'Commissionable')
		this.addBooleanProperty('isSBC', data, 'IsSBC')
		this.addBooleanProperty('refundable', data, 'Refundable')
	}
}

export interface IReservationApiSetupOption {
	BrandID?: number
	Commissionable?: string
	IsSBC?: string
	MaxPax?: number
	MinPax?: number
	OptionDesc?: string
	OptionID?: number
	OptionName?: string
	OptionShortName?: string
	OptionDisplayName?: string
	OptionTypeID?: number
	OptionType?: string
	Refundable?: string
	ServiceID?: number
	ServiceName?: string
	ServiceTypeName?: string
	Status?: string
	TaxTypeID?: number
	TaxValue?: number
	PriceSetupID?: number
	SbcMessage?: string
}

export interface IReservationApiSetupServiceOption extends IReservationApiSetupOption {
	Currency?: string
	CommissionableSO?: string
	Commissionable?: string
	CityID?: number
	City?: string
	EndDate?: string
	Message?: string
	PriceSetupID?: number
	PriceSetup?: string
	ServiceID?: number
	ServiceName?: string
	StartDate?: string
	SelfIncluded?: string
	/**
	 * Y for Service2Option inclusive
	 * N for Service2Option not inclusive
	 *
	 * @type {string}
	 * @memberof IReservationApiSetupServiceOption
	 */
	IsIncluded?: string
	/**
	 * Service2Option not inclusive ID
	 *
	 * @type {number}
	 * @memberof IReservationApiSetupServiceOption
	 */
	ServiceOptionID?: number
	/**
	 * Service2Option inclusive ID
	 *
	 * @type {number}
	 * @memberof IReservationApiSetupServiceOption
	 */
	ServiceToServiceOptionID?: number
	/**
	 * Service type of the Service2Option Service
	 *
	 * @type {number}
	 * @memberof IReservationApiSetupServiceOption
	 */
	ServiceTypeIDSO?: number
}

export class ReservationSetupServiceOptionInclusiveDetail extends SafeBaseObject {
	currencyCod?: string
	discount?: number
	discountType?: string
	endDate?: DateTime
	itineraryDate?: DateTime
	priceSetupID?: number
	priceTypeID?: number
	serviceToServiceOptionID?: number
	startDate?: DateTime
	status: string
	prePostFlag?: string

	// when isPercentage is true, this will contain all ReservationSetupServiceOptionInclusiveDetail given from the API, with the same priceTypeID
	allCurrenciesPercentageDetails: { serviceToServiceOptionID?: number; currencyCod?: string }[] = []

	get formattedStatus(): string {
		switch (this.status) {
			case 'A':
				return 'Active'
			case 'D':
				return 'Deleted'
			default:
				return ''
		}
	}

	get isSaved(): boolean {
		return this.serviceToServiceOptionID != null
	}

	get isPercentage(): boolean {
		return this.discountType?.toLocaleLowerCase() === 'percentage'
	}

	get isAvailable(): boolean {
		return this.status?.toLowerCase() === 'a'
	}

	get isDeleted(): boolean {
		return this.status?.toLowerCase() === 'd'
	}

	constructor(data?: any) {
		super()
		this.status = 'A'

		if (data) {
			this.updateData(data)
		}
	}

	override updateData(data: any): void {
		this.addMangledProperty(data)
		this.addDateTimeProperty('itineraryDate', data, 'ItineraryDate')
		this.addDateTimeProperty('endDate', data, 'EndDate')
		this.addDateTimeProperty('startDate', data, 'StartDate')
	}
}


export interface IReservationApiManageServiceOptionInclusive {
	ServiceID?: number
	OptionID?: number
	ServiceIDOption?: number
	isUpd?: string
	Status?: string
	Setup: IReservationApiManageServiceOptionInclusiveDetail[]
}

interface IReservationApiManageServiceOptionInclusiveDetail {
	ServiceToServiceOptionID?: number | null
	ItineraryDate?: DateTime
	DiscountType?: string
	Discount?: number
	CurrencyCod?: string
	PriceTypeID?: number
	PriceSetUpID?: number
	StartDate?: string
	EndDate?: string
	PrePostFlag?: string
	Status: string
}

//Geotree

export interface IReservationApiGeotree {
	GeoTreeID?: number
	GeoTreeName?: string
	GeoTreeTypeID?: number
	DestinationTypeID?: number
	DepartmentID?: number
	DepartmentName?: string
	LEVEL_1_ID?: number
	LEVEL_2_ID?: number
	LEVEL_3_ID?: number
	LEVEL_4_ID?: number
	LEVEL_5_ID?: number
	PortCod?: string
	CityCod?: string
	MainIataCod?: string
	Latitude?: number
	Longitude?: number
	ExternalCityID?: number
	ExternalCountryID?: number
	CompanyID?: number
	SalesPriority?: number
	DestinationPriority?: number
	Status?: string
	Images?: IReservationApiGeotreeImage[]
	Title?: string
	Description?: string
	isVisible?: boolean
	BestTimeToGo?: string
	TimeZone?: string
	Breadcrumbs?: string
}
export interface IReservationApiGeotreeImage {
	GeoTreeIMGID?: number
	GeoTreeID?: number
	FileID?: number
	FileGUID?: string
	FileName?: string
	Status?: string
	GeoTreeIMGType?: string
	GeoTreeIMGTypeID?: number
	CategoryName?: string
	DocCatID?: number
	ImgNote?: string
}
export interface IReservationApiCreateNewServiceOrOption {
	PackageID?: number
	PackageDay?: number
	Quantity?: number
	HideInBkg?: boolean

	ServiceID?: number
	ServiceName?: string
	ServiceShortName?: string
	ServicePriceSetupID?: number
	ServiceTypeID?: number
	ServiceCityID?: number
	ServiceSupplierID?: number

	OptionID?: number
	OptionName?: string
	OptionShortName?: string
	OptionMinPax?: number
	OptionMaxPax?: number
	OptionCommissionable?: boolean
	BrandID?: number

	CompanyID?: number
}

export interface CreateServiceOptionFormValues {
	packageDay?: number
	quantity?: number
	serviceShortName?: string
	serviceLongName?: string
	priceSetupID?: number
	companyID?: number
	serviceTypeID?: number
	cityID?: number
	supplierID?: number
	optionShortName?: string
	optionName?: string
	minPax?: number
	maxPax?: number
	serviceBrandID?: number
	commissionable?: boolean
	packageID?: number
	hideInBkg?: boolean
}

export class ReservationCreateNewServiceOrOption extends SafeBaseObject {
	packageID?: number
	packageDay?: number
	quantity?: number
	hideInBkg?: boolean

	serviceID?: number
	serviceName?: string
	servicePriceSetupID?: number
	serviceTypeID?: number
	serviceCityID?: number
	serviceSupplierID?: number

	optionID?: number
	optionName?: string
	optionShortName?: string
	optionMinPax?: number
	optionMaxPax?: number
	optionCommissionable?: boolean
	brandID?: number

	companyID?: number

	constructor(data?: IReservationApiCreateNewServiceOrOption) {
		super()
		if (data) {
			this.updateData(data)
		}
	}
}

export class ReservationBookVilla {
	villaID!: number
	dateFrom!: DateTime
	dateTo!: DateTime
}

export interface IReservationBookVilla {
	VillaID: number
	DateFrom: DateTime
	DateTo: DateTime
	RoomID: number
}
export class ReservationServicePackageListElement extends SafeBaseObject {
	packageID: number = 0;
	packageName: string = '';
	day: string = '';
	serviceID: number = 0;
	serviceName: string = '';
	optionID: number = 0;
	optionName: string = '';
	isUpgrade: string = '';

	constructor(data?: any) {
		super();
		if (data) this.updateData(data);
	}

	override updateData(data: ReservationServicePackageListElement): void {
		this.addMangledProperty(data)
		this.addBooleanProperty('isUpgrade', data, 'IsUpgrade');
	}
}
export class ReservationServiceExperienceListElement extends SafeBaseObject {
	serviceID: number = 0;
	serviceName: string = '';
	optionID: number = 0;
	optionName: string = '';
	experienceID: number = 0;
	experienceName: string = '';
	templateName: string = '';

	constructor(data?: any) {
		super();
		if (data) this.updateData(data);
	}
}
export class ReservationServiceTC extends SafeBaseObject {
	serviceID: number = 0;
	serviceName: string = '';
	optionID: number | null = null;
	optionName: string = '';

	constructor(data?: any) {
		super();
		if (data) this.updateData(data);
	}
}
export class ReservationServiceBookingReport extends SafeBaseObject {
	bkgID: number = 0;
	serviceDescription: string = '';
	/* 	commissionable: boolean = false;
		isShip: boolean = false;
		isAK: boolean = false;
		currency: string = ''; */
	bkgStatus: string = '';
	serviceID: number = -1;
	serviceShortName?: string;
	serviceLongName?: string;
	secondary: string = '';

	constructor(data?: any) {
		super();
		if (data) {
			this.updateData(data);
		}
	}
}
export class ReservationPackageServiceAllocation extends SafeBaseObject {
	packageOptionID!: number;

	day: number = 0;
	quantity: number = 0;
	serviceTypeName?: string;
	serviceShortName?: string;
	serviceLongName: string = '';
	optionName?: string;
	optionShortName?: string;
	city!: string;
	supplier?: string;
	minPax: number = 0;
	maxPax: number = 0;

	packageMaxPax: number = 99;

	packageID?: number;
	packageTravelDateID?: number;
	optionID?: number;
	serviceID?: number;
	propertyID?: number;

	constructor(data?: any) {
		super();
		if (data) {
			this.updateData(data);
		}
	}
}

export class ReservationServiceAllocation extends SafeBaseObject {
	packageID!: number;
	packageTravelDateID!: number;
	dateAlloc!: DateTime;
	serviceID?: number;
	optionID?: number;
	//initialAllotmentQTY?: number;
	//onHoldAllotmentQTY?: number;
	initialQTY?: number;
	//onHoldQTY?: number;

	constructor(data?: any) {
		super();
		if (data) {
			this.updateData(data);
		}
	}
	override updateData(data: any): void {
		this.addMangledProperty(data);
		this.addDateTimeProperty('dateAlloc', data, 'DateAlloc');
	}
}

export class CircuitType extends SafeBaseObject {
	circuitTypeID: number = -1;
	circuitType: string = '';
	constructor(data?: any) {
		super();
		if (data) {
			this.updateData(data);
		}
	}
}
export class CircuitLookupItem extends SafeBaseObject {
	circuitLookup: string = "";
	circuitLookupCode: string = "";
	circuitLookupID: number = 0;
	order: number = 0;
	scope: string = "";
	constructor(data?: any) {
		super();
		if (data) {
			this.updateData(data);
		}
	}
}
export class CircuitDiscountToService extends SafeBaseObject {
	circuitDiscountToServiceID: number = -1
	circuitDiscountID: number = -1;
	serviceID: number = -1;
	serviceName: string = '';
	optionID: number = -1;
	optionName: string = '';
	priceSetupID: number = -1;
	priceSetup: string = '';
	status: 'A' | 'D' = 'A';
	constructor(data?: any) {
		super();
		if (data) {
			this.updateData(data);
		}
	}
}

export interface ICircuitDiscountToServiceManage {
	CircuitID: number;
	DiscServices: CircuitDiscountToService[]
}

export class Circuit extends SafeBaseObject {
	circuitID: number = -1;
	circuitCod: string = '';
	circuitName: string = '';
	startDate: DateTime = DateTime.invalid('empty');
	endDate: DateTime = DateTime.invalid('empty');
	websiteVisibilityFrom: DateTime = DateTime.invalid('empty');
	websiteVisibilityTo: DateTime = DateTime.invalid('empty');
	travelPartnerVisibilityFrom: DateTime = DateTime.invalid('empty');
	travelPartnerVisibilityTo: DateTime = DateTime.invalid('empty');
	circuitTypeID: number = -1;
	automatic: boolean = false;
	isHoneymoon: boolean = false;
	combinedNights: boolean = false;
	minSrvNo: number = -1;
	validPriorToDepDays: number = 0;
	note: string = '';
	internalNotes: string = '';
	status: 'A' | 'B' | 'D' = 'B';
	companies: { companyID: number, companyName: string }[] = [];
	services?: CircuitService[];
	discounts?: CircuitDiscount[];

	constructor(data?: any) {
		super();
		if (data) {
			this.updateData(data);
		}
		if (data.Companies && data.Companies.length > 0) this.companies = data.Companies.map((el: { CompanyID: 7, CompanyName: string }) => { return { companyID: el.CompanyID, companyName: el.CompanyName } })
		if (data.Services && data.Services.length > 0) this.services = data.Services.map((el: any) => new CircuitService(el));
		if (data.Discounts && data.Discounts.length > 0) this.discounts = data.Discounts.map((el: any) => new CircuitDiscount(el));
		this.automatic = data?.Automatic === 'Y';
		this.isHoneymoon = data?.IsHoneymoon === 'Y';
		this.combinedNights = data?.CombinedNights === 'Y';
	}
}

export interface ICircuitManage {
	CircuitID?: number;
	CircuitCod?: string;
	CircuitName?: string;
	StartDate?: DateTime;
	EndDate?: DateTime;
	WebsiteVisibilityFrom?: DateTime;
	WebsiteVisibilityTo?: DateTime;
	TravelPartnerVisibilityFrom?: DateTime;
	TravelPartnerVisibilityTo?: DateTime;
	CircuitTypeID?: number;
	MinSrvNo?: number;
	ValidPriorToDepDays?: number;
	Automatic?: 'Y' | 'N';
	IsHoneymoon?: 'Y' | 'N';
	CombinedNights?: 'Y' | 'N';
	Note?: string;
	InternalNotes?: string;
	Status: 'A' | 'B' | 'D';
	CompaniesID?: string;
	Services?: Record<string, unknown>[];
	Discounts?: Record<string, unknown>[];
}

export interface ICircuitCancellationPolicy {
	CancellationPolicyID?: number;
	CircuitID: number;
	StartDate: DateTime;
	EndDate: DateTime;
	Status: string;
}

export interface ICircuitCancellationPolicyDetail {
	CancellationPolicyDetailID?: number;
	CancellationPolicyID?: number;
	CircuitID: number;
	DaysFrom: number;
	DaysTo: number;
	AmountPerc: number;
	FixedAmount: number;
	Currency?: string;
	Status: string;
}

export interface ICircuitPenaltiesManage {
	CircuitID: number;
	CircuitCancellationPolicy: ICircuitCancellationPolicy[];
	CircuitCancellationPolicy_Detail: ICircuitCancellationPolicyDetail[];
}

export class CircuitService extends SafeBaseObject {
	circuitToServiceID: number = -1;
	circuitID: number = -1;
	serviceTypeName: string = '';
	supplierID: number = -1;
	supplierName: string = '';
	serviceID: number = -1;
	serviceName: string = '';
	optionID: number = -1;
	optionName: string = '';
	startDate: DateTime = DateTime.invalid('empty');
	endDate: DateTime = DateTime.invalid('empty');
	mandatory: boolean = false;
	note: string = '';
	status: 'A' | 'D' = 'A';

	constructor(data?: any) {
		super();
		if (data) {
			this.updateData(data);
		}
		this.mandatory = data?.Mandatory === 'Y';
	}
}
export class CircuitDiscount extends SafeBaseObject {
	circuitDiscountID: number = -1;
	circuitID: number = -1;
	serviceTypeName: string = '';
	supplierID: number = -1;
	supplierName: string = '';
	serviceID: number = -1;
	serviceName: string = '';
	optionID: number = -1;
	optionName: string = '';
	priceSetupID: number = -1;
	priceSetup: string = '';
	percentage?: number = 0;
	fixedAmount?: number = 0;
	currency?: string = '';
	startDate: DateTime = DateTime.invalid('empty');
	endDate: DateTime = DateTime.invalid('empty');
	nightFrom: number = 0;
	nightTo: number = 0;
	note: string = '';

	ageFrom: number = 0;
	ageTo: number = 0;
	maxPax: number = 0;
	minSrvNo: number = 0;
	discountedNight: number = 0;
	isSupplement: boolean = false;
	discRuleCod: string[] = [];
	discBkgTypeCod: string[] = [];

	status: 'A' | 'D' = 'A';
	constructor(data?: any) {
		super();
		if (data) {
			this.updateData(data);
		}
		if (data.DiscBkgTypeCod) {
			const cod = (<string>data.DiscBkgTypeCod).split(',');
			this.discBkgTypeCod = Array.isArray(cod) ? cod : [cod]
		}
		if (data.DiscRuleCod) {
			const rueleCod = (<string>data.DiscRuleCod).split(',');
			this.discRuleCod = Array.isArray(rueleCod) ? rueleCod : [rueleCod]
		}
	}
}

export interface IResApiGetServiceOptionDayByDayParams {
	ServiceID?: number,
	OptionID?: number,
}

export class ResServiceOptionDayByDay extends SafeBaseObject {
	serviceDayByDayID = 0
	serviceID = 0
	optionID = 0
	day = 0
	mealID = ''
	itineraryTypeID = 1
	itineraryDayTitle = ''
	companyID?: number
	sequence = 0
	itineraryDayDesc = ''
	itineraryDayDescAI = ''
	dayItinerary: ResServiceOptionDayByDayDetail[] = [];
	status = 'A'
	flagLastDay = false

	constructor(data?: any) {
		super();
		if (data) {
			this.updateData(data);
			if (data.MealID && data.MealID !== "") this.mealID = data.MealID.split(',');
			if (data.DayItinerary && data.DayItinerary.length > 0) this.dayItinerary = data.DayItinerary.map((d: any) => new ResServiceOptionDayByDayDetail(d));
		}
	}
}

export class ResServiceOptionDayByDayDetail extends SafeBaseObject {
	serviceDayByDayDetailID = 0
	serviceDayByDayID = 0
	day = 0
	serviceID = 0
	optionID = 0
	sequence = 0
	cityIDFrom = 0
	cityFrom = ''
	cityIDTo = 0
	cityTo = ''
	movingTypeID = 0
	timeFrom = DateTime.invalid('empty')
	timeTo = DateTime.invalid('empty')
	title = ''
	description = ''
	durationHour?: number
	durationMin?: number
	flagPrevDay = false
	hideInWebsite = false
	itineraryDayTitle = ''
	itineraryTypeID = 1
	status = 'A'

	constructor(data?: any) {
		super();
		if (data) {
			this.updateData(data);
		}
	}
}

export interface IResApiManageServiceOptionDayByDayParams {
	ServiceID?: number
	OptionID?: number
	SrvDayByDay: IResApiManageServiceOptionDayByDayItem[]
	SrvDayByDayDet: IResApiManageServiceOptionDayByDayItemDetail[]
}

export interface IResApiManageServiceOptionDayByDayItem {
	ServiceDayByDayID?: number
	ServiceID?: number
	OptionID?: number
	ItineraryTypeID?: number
	Day?: number
	ItineraryDayTitle?: string
	MealID?: string
	ItineraryDayDesc?: string
	ItineraryDayDescAI?: string
	Sequence?: number
	CompanyID?: number
	Status?: string
	FlagLastDay?: string
}

export interface IResApiManageServiceOptionDayByDayItemDetail {
	ServiceDayByDayDetailID?: number
	ServiceDayByDayID?: number
	ServiceID?: number
	OptionID?: number
	ItineraryTypeID?: number
	Day?: number
	Sequence?: number
	CityIDFrom?: number
	CityIDTo?: number
	MovingTypeID?: number
	TimeFrom?: DateTime
	TimeTo?: DateTime
	Description?: string
	Title?: string
	DurationHour?: number
	DurationMin?: number
	FlagPrevDay?: string
	HideInWebsite?: string
	Status?: string
}

export class ResServiceOptionChildSetup extends SafeBaseObject {
	serviceAdditionalOptionChildID = 0
	serviceAdditionalOptionID = 0
	serviceID = 0
	optionID = 0
	priceSetupID = 0
	priceSetup = ''
	childNumberFrom = 0
	childNumberTo = 0
	fromAge = 0
	toAge = 0
	cost?: number
	costCurrency = ''
	priceUSD?: number
	priceGBP?: number
	priceAUD?: number
	priceEUR?: number
	priceCAD?: number
	priceCostCurrency?: number
	note = ''
	status = 'A'

	constructor(data?: any) {
		super();
		if (data) {
			this.updateData(data);
		}
	}
}

export interface IResApiManageServiceOptionChildSetup {
	ChildExtra: IResApiManageServiceOptionChildSetupRow[]
}

export interface IResApiManageServiceOptionChildSetupRow {
	ServiceAdditionalOptionChildID?: number
	ServiceAdditionalOptionID?: number
	ServiceID?: number
	OptionID?: number
	PriceSetupID?: number
	ChildNumberFrom?: number
	ChildNumberTo?: number
	FromAge?: number
	ToAge?: number
	Cost?: number
	CostCurrency?: string
	PriceUSD?: number
	PriceGBP?: number
	PriceAUD?: number
	PriceEUR?: number
	PriceCAD?: number
	PriceCostCurrency?: number
	Note?: string
	Status?: string
}

export class ResServiceConnectedList extends SafeBaseObject {
	serviceID = 0
	serviceLongName = ''
	companyID = 0
	companyName = ''

	constructor(data?: any) {
		super();
		if (data) {
			this.updateData(data);
		}
	}
}

export class ResAdmCircuitBookingList extends SafeBaseObject {
	company = ''
	bkgID = 0
	bkgStatus = ''
	bkgCurrency = ''
	creationDate = DateTime.invalid('empty')
	travelStartDate = DateTime.invalid('empty')
	travelEndDate = DateTime.invalid('empty')
	ownerType = ''
	agency = ''
	guest = ''
	passportNumber = ''
	passportIssuePlace = ''
	passportIssueDate = DateTime.invalid('empty')
	passportExpireDate = DateTime.invalid('empty')

	constructor(data?: any) {
		super();
		if (data) {
			this.updateData(data);
		}
	}
}

